import type { RouteRecordRaw } from "vue-router"

const supportRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "profileSupport",
    component: () => import("@/templates/support/Support.vue"),
    meta: { breadcrumb: "support.support" }
  }
]

export default supportRoutes
